<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="bgFotoMRestaurant">
        <div class="overlayHotel">
          <div class="row justify-content-center align-items-center text-center">
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 center">
              <h3 class="Header__title px-5">{{ $t("Restaurant & Konditorei") }}</h3>
              <p class="Header__text">
                {{ $t("DasHotelWeinhausEberitzschistidealerAusgangspunktText") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="row py-5 align-items-center justify-content-center">
          <div class="col-lg-8 align-items-center text-center">
            <h2 class="mb-4">{{ $t("Unser Restaurant") }}</h2>
            <p>
             {{ $t("WillkommeninunseremgemütlichenRestaurantText" ) }} 
             
            </p>
            <p>
              {{ $t("WillkommeninunseremgemütlichenRestaurantText2" ) }}
            </p>
            <p>
              {{ $t("WillkommeninunseremgemütlichenRestaurantText3" ) }}
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="row py-5 align-items-center justify-content-center">
          <div class="col-lg-8 align-items-center text-center">
            <KarussellRestaurant2 />
          </div>
        </div>
      </section>
      <section>
        <div class="row py-5 align-items-center justify-content-center">
          <div class="col-lg-8 align-items-center text-center">
            <h2 class="mb-4">{{ $t("UnsereKonditorei") }}</h2>
            <p>
              {{ $t("UnsereKonditoreiText") }}
            </p>
            <p>
              {{ $t("UnsereKonditoreiText1") }}
            </p>
            <p>
              {{ $t("UnsereKonditoreiText2") }}
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="row py-5 align-items-center justify-content-center">
          <div class="col-lg-8 align-items-center text-center">
            <KarussellRestaurant3 />
          </div>
        </div>
      </section>

      <!-- hier pdf anzeigen -->
      <section>
        <div class="row py-5 align-items-center justify-content-center">
          <div class="col-lg-6 align-items-center text-center">
            <h2 class="mb-4">{{ $t("Unsere Speisekarte") }}</h2>
            <PdfViewer :src="'/Speisekarten/Speisekarte.pdf'" />
            <!-- <div class="pdf-viewer my-4">
              <iframe
                src="/Speisekarten/Speisekarte.pdf"
                width="100%"
                height="800px"
                type="application/pdf"
                style="border: 1px solid #ddd; border-radius: 8px"
              >
                <p>
                  Ihr Browser unterstützt keine eingebetteten PDFs.
                  <a href="/Speisekarten/Speisekarte.pdf" target="_blank">
                    Klicken Sie hier zum Download
                  </a>
                </p>
              </iframe>
            </div> -->
            <a
              href="/Speisekarten/Speisekarte.pdf"
              target="_blank"
              class="btn btn-primary mt-3"
              >{{ $t("SpeisekartealsPDFherunterladen") }}</a
            >
            <div class="qr-box">
              <qrcode-vue
                :value="qrText"
                :size="200"
                level="H"
                foreground="#000000"
                background="#ffffff"
              />
            </div>
          </div>
        </div>
      </section>
       <section>
        <div class="container-fluid pb-5" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="willkommen__title2 py-5 col-lg-6 d-flex flex-column align-items-center text-center">
              {{ $t("Reservierungsanfrage") }}
            </div>
          </div>
          <!-- Name -->
          <div class="row align-items-center justify-content-center">
           
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Name*") }}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="mail.name"
                      v-bind:class="background.name"
                />
              </div>
            </div>
          </div>
          <!-- Email -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Email*") }}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  v-model="mail.email"
                      v-bind:class="background.email"
                />
              </div>
              <p v-if="!isValidEmail && mail.email" class="text-danger">{{ $t("Ungültige E-Mail-Adresse") }}</p>
            </div>
          </div>
          <!-- Telefon -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Telefon:") }}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Telefon"
                  v-model="mail.telefon"
                />
              </div>
            </div>
          </div>
          <!-- DAtum -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Datum:") }}*</span>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Datum"
                  v-model="mail.datum"
                   v-bind:class="background.datum"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Uhrzeit:") }}*</span>
                <input
                  type="time"
                  class="form-control"
                  placeholder="Uhrzeit"
                  v-model="mail.uhrzeit"
                   v-bind:class="background.uhrzeit"
                />
              </div>
            </div>
          </div>

          <!-- Zimmer -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <input
                  type="number"
                  class="form-control mailnumber"
                  placeholder="Anzahl Personen"
                  v-model="mail.personen"
                   v-bind:class="background.personen"
                  min="1"
                />
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("Anzahl Personen:") }}*</span
                >
              </div>
            </div>            
          </div>       

          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="mb-3">
                <label for="exampleFormControlTextarea1" class="form-label"
                  >{{ $t("Nachricht:") }}</label
                >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  v-model="mail.message"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="mail.datenschutz"
                      v-bind:class="background.datenschutz"
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                 * {{ $t("Die Angaben zum") }}
                  <router-link to="/Datenschutz" class="">{{
                    $t("Datenschutz")
                  }}</router-link>
                  {{ $t("habe ich gelesen .") }}
                </label>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <button type="button" class="btn btn-primary" @click="sendMail()">
                {{ $t("Anfrage senden") }}
              </button>
              </div>
          </div> 
          <div class="row">
            <div class="col-md-12">
              {{ mail.gesendet }}
            </div>
          </div>
        </div>
      </section>
    </div>
    <stickybarTelMail />
  </div>
  <stickyPfeil />
</template>

<script>
//import carouselHeader from "../components/carouselHeader.vue";
import axios from "axios";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
import KarussellRestaurant2 from "../components/KarussellRestaurant2.vue";
import KarussellRestaurant3 from "../components/KarussellRestaurant3.vue";
import QrcodeVue from "qrcode.vue";


export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newSite: null,
      qrText: "https://weinhaus-eberitzsch.de/Speisekarten/Speisekarte.pdf",
      mail: {
        name: "",
        email: "",
        message: "",
        telefon: "",
        personen: 0,
        datum: "",
        uhrzeit: "",
        datenschutz: false,
        gesendet: "",
      },
      background: {
        name: "",
        email: "",
        message: "",
        datenschutz: "",
        datum: "",
        uhrzeit: "",
        personen: "",
      },
    };
  },
  components: {
    stickybarTelMail,
    stickyPfeil,
    QrcodeVue,
    KarussellRestaurant2,
    KarussellRestaurant3,
    //  carouselHeader,
  },
  methods: {
checkEingaben() {
      let re = true;
      if (this.mail.name == "") {
        this.background.name = "border border-2 border-danger";
        re = false;
      } else {
        this.background.name = "border border-2 border-success";
      }
      if (this.mail.email == "") {
        this.background.email = "border border-2 border-danger";
        re = false;
      } else {
        this.background.email = "border border-2 border-success";
      }
      if (this.mail.datum == "") {
        this.background.datum = "border border-2 border-danger";
        re = false;
      } else {
        this.background.datum = "border border-2 border-success";
      }
      if (this.mail.uhrzeit == "") {
        this.background.uhrzeit = "border border-2 border-danger";
        re = false;
      } else {
        this.background.uhrzeit = "border border-2 border-success";
      }
      if (this.mail.personen == "") {
        this.background.personen = "border border-2 border-danger";
        re = false;
      } else {
        this.background.personen = "border border-2 border-success";
      }
      if (this.mail.datenschutz == false) {
        this.background.datenschutz = "bg-danger";
        re = false;
      } else {
        this.background.datenschutz = "bg-success";
      }

      return re;
    },
    sendMail() {
      if (this.checkEingaben()) {
        const axiosConfig = {
          headers: {
            Accept: "text/plain",
            "Content-Type": "text/plain",
          },
        };
        const payload = {
          //empfaenger: "joerg@pillar.de",
          empfaenger: "info@weinhaus-eberitzsch.de",
          Name: this.mail.name,
          Email: this.mail.email,
          Telefon: this.mail.telefon,
          Text: this.mail.message,
          Datum: this.mail.datum,
          Uhrzeit: this.mail.uhrzeit,
          Personen: this.mail.personen,       
          Datenschutz: this.mail.datenschutz,
        };
        let mail = this.mail;
        let background = this.background;
        axios
          .post("https://pillar.de/mailrelay/post_attachment.php", payload, axiosConfig)
          .then((response) => {
            console.log("success", response.data);
            mail.gesendet = "Ihre Anfrage wurden erfolgreich versendet";
            mail.name = "";
            background.name = "";
            mail.email = "";
            background.email = "";
            mail.message = "";
            background.message = "";
            mail.datenschutz = false;
            background.datenschutz = "";
            mail.telefon = "";
            background.telefon = "";
            mail.datum = "";
            background.datum = "";
            mail.uhrzeit = "";
            background.uhrzeit = "";
            mail.personen = 0;
            background.personen = "";
            


          })
          .catch((error) => {
            console.log(error.response);
            mail.gesendet =
              "Ihre Kontaktdaten konnten leider nicht gesendet werden. Bitte rufen Sie uns an.";
          });
      }
    },},
  computed: {
     isValidEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.mail.email);
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
    };
  },
};
</script>

<style scoped></style>
